<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous supprimer le matériel <strong>{{materiel.nom}}</strong> ({{materiel.materielType }}) ?
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Supprimer
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'materiel',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('deactivateMateriel', this.materiel)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// MaterielDelete.vue?11b04dea